// extracted by mini-css-extract-plugin
export default {"tokenButton":"MenuButton_tokenButton__RWO35","icon":"MenuButton_icon__mYRsS","text":"MenuButton_text__VudX6","active":"MenuButton_active__g80mP"};